import { Checkcircle } from '~/commonComponents';

interface IProps {
  text: string | number;
  checked: boolean;
  onClick: () => void;
  textStyle?: React.CSSProperties;
  disabled?: boolean;
  size?: 'md' | 'lg';
  style?: React.CSSProperties;
  dataCy?: string;
}

export const RadioOption = ({
  text,
  checked,
  onClick,
  textStyle = {},
  disabled = false,
  size = 'md',
  style = {},
  dataCy,
}: IProps) => (
  <button
    data-cy={dataCy}
    data-checked={checked}
    type="button"
    style={{
      all: 'unset',
      display: 'flex',
      cursor: disabled ? 'not-allowed' : 'pointer',
      alignItems: 'center',
      ...style,
    }}
    onClick={onClick}
    disabled={disabled}
  >
    <Checkcircle checked={checked} size={size} />

    <p
      className="global_font f-dark"
      style={{
        margin: '0px 0px 0px 12px',
        ...textStyle,
      }}
    >
      {text}
    </p>
  </button>
);
